import styles from "./styles.module.scss";

export const QuantumPdApplication = () => {
  return (
    <div className={styles.trainAwsPdApplication}>
      <div className="container">
        <div className={styles.iframeContainer}>
          <iframe
            id="JotFormIFrame-240515362895057"
            title="Quantum PD Application"
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            allowfullscreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/240515362895057"
          >
          </iframe>
        </div>
      </div>
    </div>
  );
};
